import React from "react";
import Seo from "components/Seo";
import NoticeDetail from "common/pages/common/-pages/support/NoticeDetail";
import SupportLayout from "./supportLayout";

const MorningNoticeDetail = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="공지사항" />
            <SupportLayout>
                <NoticeDetail type="morning" />
            </SupportLayout>
        </React.Fragment>
    );
};

export default MorningNoticeDetail;
